import { gql } from '@apollo/client'

const LOCATION_LIST_FRAGMENT = gql`
  fragment LocationListFragment on Location {
    id
    autoeatId
    name
    website
    status
    isPublished
    isDeleted
    isFake
    updatedAt
    createdAt
    isQcDone
    isQaDone
    isCurationDone
    isRequiringAttention
    isPublished

    mainLocationType {
      id
      name
    }

    cuisineType {
      id
      name
    }

    additionalLocationTypes {
      id
      name
    }

    awards {
      id
      name
    }

    menuCurationTaskIds
  }
`

export default LOCATION_LIST_FRAGMENT
